<template>
  <div>
    <section
      id="slider"
      class="swiper_wrapper slider-element slider-parallax full-screen force-full-screen slider-parallax-visible"
      style="height: 930px;"
    >
      <div class="slider-parallax-inner" style="height: 930px; transform: translateY(0px);">
        <div
          class="full-screen force-full-screen dark section nopadding nomargin noborder ohidden"
          style="height: 930px;"
        >
          <div class="container clearfix">
            <div class="slider-caption">
              <h1 class="nott" data-animate="fadeInUp">Toplumsal Cinsiyet Eşitliği</h1>
              <p
                style="font-size: 17px; font-weight: 500; letter-spacing: .7px"
                data-animate="fadeInUp"
                data-delay="200"
              >
                Kadınların, tüm sektörlerde ve her düzeyde, ekonomik yaşamın
                içinde yer almasını ve güçlenmesini hedefleyen, özel sektörün
                küresel ve en önemli girişimlerinden biri olan Kadının
                Güçlenmesi Prensipleri’ni kendimize rehber alıyoruz.
              </p>
              <router-link
                to="/weps"
                data-animate="fadeInUp"
                data-delay="400"
                class="button button-rounded button-large button-light text-dark bgcolor shadow nott ls0 ml-0 mt-4"
              >Daha Fazlası</router-link>
            </div>
          </div>
          <div class="video-wrap">
            <video
              poster="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/birliktegucluyuz.org%2F1.jpg?alt=media&token=3c5ac447-a76e-412e-9be2-11f2dc7b1bc6"
              preload="auto"
              loop="true"
              autoplay="true"
              muted="true"
              id="vidvid"
              style="width: 1903px; height: 1070.44px; top: -70.2188px;"
            >
              <source
                src="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/birliktegucluyuz.org%2F1.mp4?alt=media&token=30437c7d-fdee-4c82-a5f4-48a577c7c045"
                type="video/mp4"
              />
            </video>
            <div class="video-overlay" style="background-color: rgba(0,0,0,0.2);"></div>
          </div>
          <a
            href="#"
            data-scrollto="#section-about"
            data-easing="easeInOutExpo"
            data-speed="1250"
            data-offset="65"
            class="one-page-arrow dark"
          >
            <i class="icon-angle-down infinite animated fadeInDown"></i>
          </a>
        </div>
      </div>
    </section>

    <section id="content" style="overflow: visible">
      <div class="content-wrap p-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1382 58"
          width="100%"
          height="60"
          preserveAspectRatio="none"
          style="position: absolute; top: -58px; left:0; z-index: 1"
        >
          <path style="fill:#FFF;" d="M1.52.62s802.13,127,1380,0v56H.51Z" />
        </svg>
        <div class="container clearfix">
          <div class="slider-feature w-100">
            <div class="row justify-content-center">
              <div class="col-md-3 px-1">
                <a
                  href="/misyonumuz"
                  class="card center border-left-0 border-right-0 border-top-0 border-bottom border-bottom shadow py-3 noradius t600 uppercase ls1"
                >
                  <div class="card-body">
                    <i class="icon-line-align-center"></i>Misyonumuz
                  </div>
                </a>
              </div>
              <div class="col-md-3 px-1">
                <a
                  href="/vizyonumuz"
                  class="card center border-left-0 border-right-0 border-top-0 border-bottom border-bottom shadow py-3 noradius t600 uppercase ls1"
                >
                  <div class="card-body">
                    <i class="icon-line-umbrella"></i>Vizyonumuz
                  </div>
                </a>
              </div>
              <div class="col-md-3 px-1">
                <a
                  href="javascript:void(0)"
                  class="get-help card center border-left-0 border-right-0 border-top-0 border-bottom border-bottom shadow py-3 noradius t600 uppercase ls1"
                >
                  <div class="card-body">
                    <i class="icon-line-mail"></i>Destek Al
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid my-5 clearfix">
          <div
            class="d-flex flex-column align-items-center justify-content-center center counter-section position-relative py-5"
            style="background: url('demos/nonprofit/images/world-map.png') no-repeat center center/ contain"
          >
            <div class="divcenter center" style="max-width: 1000px">
              <h3>Platformumuz büyüyor, gelişiyor ve ilham vermeye devam ediyor.</h3>
            </div>
            <div class="row align-items-stretch m-0 w-100 clearfix">
              <div class="col-lg-4 col-sm-6 center mt-5">
                <img
                  src="demos/nonprofit/images/icons/hotel.svg"
                  alt="Counter Icon"
                  width="70"
                  class="mb-4"
                />
                <div class="counter font-secondary">
                  <span
                    data-from="100"
                    data-to="21"
                    data-refresh-interval="50"
                    data-speed="2100"
                    data-comma="true"
                  ></span>
                </div>
                <h5 class="nott ls0 mt-0">
                  <u>Üye Şirket</u>
                </h5>
              </div>
              <div class="col-lg-4 col-sm-6 center mt-5">
                <img
                  src="demos/nonprofit/images/icons/shelter.svg"
                  alt="Counter Icon"
                  width="70"
                  class="mb-4"
                />
                <div class="counter font-secondary">
                  <span
                    data-from="100"
                    data-to="28000"
                    data-refresh-interval="50"
                    data-speed="2200"
                    data-comma="true"
                  ></span>+
                </div>
                <h5 class="nott ls0 mt-0">
                  <u>Çalışan</u>
                </h5>
              </div>
              <div class="col-lg-4 col-sm-6 center mt-5">
                <img
                  src="demos/nonprofit/images/icons/team.svg"
                  alt="Counter Icon"
                  width="70"
                  class="mb-4"
                />
                <div class="counter font-secondary">
                  <span
                    data-from="100"
                    data-to="100000"
                    data-refresh-interval="25"
                    data-speed="2300"
                    data-comma="true"
                  ></span>+
                </div>
                <h5 class="nott ls0 mt-0">
                  <u>Ulaşılan Kadın Çalışan</u>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="section my-3">
          <div class="container my-5">
            <div class="row justify-content-center">
              <div class="col-lg-8 col-md-10 col-12 text-center">
                <h2>
                  Biz, çerçevesine sığmayıp sınırlarını aşan ve toplumsal
                  cinsiyet eşitliği konusunda ihtiyaç duyulan değişime destek
                  veren tüm kadınlarla #BirlikteGüçlüyüz!
                </h2>
                <p class="lead">Seninle Daha Güçlüyüz!</p>
                <a
                  href="javascript:void(0)"
                  class="get-help button button-rounded button-large button-light text-dark bgcolor shadow nott ls0 ml-0 mt-1 fadeInUp animated"
                >Hadi Bize Katıl!</a>
              </div>
            </div>
          </div>
        </div>
        <div class="section nobg" style="padding: 80px 0 20px">
          <div class="container clearfix">
            <div class="row justify-content-center">
              <div class="col-md-7 center">
                <div class="heading-block nobottomborder mb-4">
                  <h2 class="mb-4 nott">Platform Üyeleri</h2>
                </div>
                <div class="svg-line bottommargin-sm clearfix">
                  <img src="demos/nonprofit/images/divider-1.svg" alt="svg divider" height="15" />
                </div>
              </div>
              <div class="clear"></div>
              <div class="col-md-11 my-5">
                <div class="row custom-clients">
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/agrilink.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/alisan.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/altunbilekler.png" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/anlatsin.png" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/aromsa.png" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/barrycallebaut.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/bicen.png" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/duran-dogan.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/ipsos.png" style="width: 80px;" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/kalekimya.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/korozo.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/mnk.png" style="width: 80px;" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/ogilvy.jpg" style="width: 80px;" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/olmuksan.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/onur.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/sariyer.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/solvay.png" style="width: 80px;" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/ucler.jpg" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/unite.png" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/unilever.png" style="width: 80px;" alt="Clients" />
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6">
                    <img src="images/clients/watsons.png" alt="Clients" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section nobg" style="padding: 0;">
          <div class="container-fluid">
            <div
              class="footer-widgets-wrap clearfix"
              style="background: url('https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/ON2_8131.JPG?alt=media&token=93c2e55d-e9bf-4903-9fda-cd60570e14da') repeat center center / cover;  padding: 150px 0; background-color: #00000080;"
            >
              <div class="divcenter center" style="max-width: 700px;">
                <h2 class="display-2 t700 text-white mb-0 ls1 font-secondary mb-4">
                  <br />Değiş ve Etkile
                </h2>
                <a
                  href="javascript:void(0)"
                  class="get-help button button-rounded button-xlarge bg-white text-dark shadow nott ls0 ml-0 mt-5"
                >Bize Katıl!</a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="section"
          style="background: #FFF url('demos/nonprofit/images/others/1.png') no-repeat 100% 50% / auto 25vw;"
        >
          <div class="container clearfix">
            <div class="row justify-content-center">
              <div class="col-md-7 center">
                <div class="heading-block nobottomborder mb-4">
                  <h2 class="mb-4 nott">Birlikte Güçlüyüz</h2>
                </div>
                <div class="svg-line bottommargin-sm clearfix">
                  <img src="demos/nonprofit/images/divider-1.svg" alt="svg divider" height="20" />
                </div>
                <p>
                  Biz, çerçevesine sığmayıp sınırlarını aşan ve toplumsal
                  cinsiyet eşitliği konusunda ihtiyaç duyulan değişime destek
                  veren tüm kadınlarla #BirlikteGüçlüyüz!
                </p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 mb-5">
                <div class="feature-box pl-0">
                  <div class="fbox-media position-relative">
                    <img
                      src="demos/nonprofit/images/icons/donate.svg"
                      alt="Featured Icon"
                      width="60"
                      class="mb-3"
                    />
                  </div>
                  <div class="fbox-desc">
                    <h3 class="nott ls0">
                      <a href="#" class="text-dark">Birlikte Güçlüyüz</a>
                    </h3>
                    <p>
                      Platformumuz büyüyor, gelişiyor ve ilham vermeye devam
                      ediyor. Hadi sen de katkıda bulun!
                    </p>
                    <router-link
                      to="/neler-yaptik"
                      class="button button-rounded button-border nott ls0 t400 ml-0 mt-4"
                    >Daha Fazlasını Öğren</router-link>
                  </div>
                </div>
              </div>
              <div class="col-md-3 mb-5">
                <div class="feature-box pl-0">
                  <div class="fbox-media position-relative">
                    <img
                      src="demos/nonprofit/images/icons/volunteer.svg"
                      alt="Featured Icon"
                      width="60"
                      class="mb-3"
                    />
                  </div>
                  <h3 class="nott ls0">
                    <a href="javascript:void(0)" class="get-help text-dark">Gönüllü Olun</a>
                  </h3>
                  <p>
                    Çerçevesine sığmayıp sınırlarını tüm kadınlarla
                    #BirlikteGüçlüyüz! Gel daha da güçlü olalım!
                  </p>
                  <a
                    href="javascript:void(0)"
                    class="get-help button button-rounded button-border nott ls0 t400 ml-0 mt-4"
                  >Gönüllü Ol!</a>
                </div>
              </div>
              <div class="col-md-3 mb-5">
                <div class="feature-box pl-0">
                  <div class="fbox-media position-relative">
                    <img
                      src="demos/nonprofit/images/icons/educated.svg"
                      alt="Featured Icon"
                      width="60"
                      class="mb-3"
                    />
                  </div>
                  <h3 class="nott ls0">
                    <a href="javascript:void(0)" class="get-help text-dark">Bizden Yararlanın</a>
                  </h3>
                  <p>
                    Ne mi yapabilirsin? Bize ulaş, yardım edelim ve toplumsal
                    cinsiyet eşitliğini sağlamak için adımlar atalım!
                  </p>
                  <a
                    href="javascript:void(0)"
                    class="get-help button button-rounded button-border nott ls0 t400 ml-0 mt-4"
                  >Destek Al!</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="w-100 position-relative">
            <h2 class="text-center">#BirlikteGüçlüyüz</h2>
            <video
              class="w-100"
              controls
              poster="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/2019-09-04_10-52-42.png?alt=media&token=63dc532a-2a55-4cb5-a2f7-85a07a62b618"
              src="https://firebasestorage.googleapis.com/v0/b/bgplatformu-9d0d3.appspot.com/o/Birlikte%20G%C3%BC%C3%A7l%C3%BCy%C3%BCz%20V4.mp4?alt=media&token=7cf2c2ac-bbf7-44de-8e61-a230348e901e"
            ></video>
          </div>
        </div>
        <div class="clear"></div>
        <div class="bgcolor subscribe-section position-relative" style="margin-top: 100px;">
          <loading :active.sync="busy" :is-full-page="false"></loading>
          <div class="container" style="z-index: 2;">
            <div
              class="center collapsed subscribe-section-target"
              data-toggle="collapse"
              data-target="#target-1"
            >
              <div class="subscribe-icon">
                <i class="icon-envelope21 text-white"></i>
              </div>
              <h2 class="mb-0 mt-2 position-relative text-white" style="z-index: 1;">
                Bizden Haberdar Olmak İçin Tıkla
                <i
                  class="icon-arrow-down position-relative"
                  style="top: 5px"
                ></i>
              </h2>
            </div>
            <div class="collapse" id="target-1">
              <div class="form-widget pb-5" data-alert-type="false">
                <div class="form-result"></div>
                <div class="nonprofit-loader css3-spinner" style="position: absolute;">
                  <div class="css3-spinner-bounce1"></div>
                  <div class="css3-spinner-bounce2"></div>
                  <div class="css3-spinner-bounce3"></div>
                </div>
                <div
                  id="nonprofit"
                  class="row mt-2 justify-content-center"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <div class="col-md-6 col-12 mb-4 mb-md-1">
                    <label for="nonprofit-email" class="text-white">Email:</label>
                    <input
                      type="email"
                      v-model="email"
                      name="nonprofit-email"
                      id="nonprofit-email"
                      class="form-control border-form-control required"
                    />
                  </div>
                  <button
                    @click="sendForm"
                    v-bind:disabled="!valid"
                    name="nonprofit-submit"
                    class="btn button button-rounded button-xlarge button-dark bg-dark shadow nott ls0 m-0 subscribe-button"
                  >Haberdar Ol!</button>
                  <input type="hidden" name="prefix" value="nonprofit-" />
                </div>
              </div>
            </div>
          </div>
          <div
            style="background-image: url('demos/nonprofit/images/divider-4.svg'); position: absolute; bottom: -20px; left: 0; width: 100%; height: 60px; z-index: 1;"
          ></div>
        </div>
        <div class="my-3 py-5">
          <div class="container my-5">
            <div class="row justify-content-center">
              <div class="col-lg-8 col-md-10 col-12 text-center">
                <h2>
                  Biz, çerçevesine sığmayıp sınırlarını aşan ve toplumsal
                  cinsiyet eşitliği konusunda ihtiyaç duyulan değişime destek
                  veren tüm kadınlarla #BirlikteGüçlüyüz!
                </h2>
                <p class="lead">Seninle Daha da Güçlüyüz!</p>
                <a
                  href="javascript:void(0)"
                  class="get-help button button-rounded button-large button-light text-dark bgcolor shadow nott ls0 ml-0 mt-1 fadeInUp animated"
                >Hadi Bize Katıl!</a>
              </div>
            </div>
          </div>
        </div>

        <div class="line line-sm my-0 clearfix"></div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { fs } from "../main";
export default {
  data() {
    return {
      email: "",
      busy: false,
      valid: false
    };
  },
  mounted() {
    this.$root.$emit("loaded");
    document.getElementById("vidvid").play();
    jQuery(".get-help").click(e => {
      jQuery(".floating-contact-btn").trigger("click");
    });
    jQuery("#target-1").on("shown.bs.collapse", function() {
      jQuery("#nonprofit-email").focus();
    });
  },
  watch: {
    email: function(val) {
      console.log(val);
      this.valid = this.validateEmail(val);
    }
  },
  methods: {
    sendForm() {
      let self = this;
      self.busy = true;
      if (self.validateEmail(self.email)) {
        fs.collection("subscriptions")
          .add({
            email: self.email
          })
          .then(e => {
            alert("Mailiniz kaydedildi!");
            self.busy = false;
            self.email = "";
          });
      }
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>
